import React from 'react';
import { maiaAgents } from '../../data/mockData';

const MaiaModal = ({ state }) => {
  const {
    selectedAgents,
    maiaQuery,
    maiaResponse,
    maiaHistory,
    setShowMaia,
    setMaiaQuery,
    toggleAgent,
    runMaiaQuery,
    saveResearchToOpportunity,
    discardResearch,
  } = state;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.9)',
      display: 'flex',
      zIndex: 1000,
    }}>
      {/* Left Sidebar - Query History */}
      <div style={{
        width: 280,
        backgroundColor: '#0a0a14',
        borderRight: '1px solid #1e1e32',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <button
          style={{
            margin: 16,
            padding: '12px 16px',
            backgroundColor: '#1e1e32',
            border: '1px solid #2d2d44',
            borderRadius: 8,
            color: '#f3f4f6',
            fontSize: 14,
            fontWeight: '500',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}
        >
          <span style={{ fontSize: 16 }}>+</span> New Query
        </button>

        <div style={{ padding: '0 16px', marginBottom: 8 }}>
          <div style={{ fontSize: 12, color: '#6b7280', fontWeight: '500', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>{'\uD83D\uDD50'}</span> History
          </div>
        </div>

        <div style={{ flex: 1, overflow: 'auto', padding: '0 8px' }}>
          {maiaHistory.map(item => (
            <div
              key={item.id}
              style={{
                padding: '12px',
                borderRadius: 8,
                marginBottom: 4,
                cursor: 'pointer',
                backgroundColor: 'transparent',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1e1e32'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <div style={{ fontSize: 13, color: '#d1d5db', marginBottom: 4, lineHeight: 1.4 }}>
                {item.title}
              </div>
              <div style={{ fontSize: 11, color: '#6b7280' }}>{item.timestamp}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Main Content Area */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#0f0f1a'
      }}>
        {/* Header */}
        <div style={{
          padding: '20px 32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h1 style={{ margin: 0, fontSize: 28, fontWeight: '600', color: '#f3f4f6' }}>
            Turn complex questions into decision-ready insights.
          </h1>
          <button
            onClick={() => setShowMaia(false)}
            style={{
              background: 'none',
              border: 'none',
              color: '#6b7280',
              fontSize: 28,
              cursor: 'pointer',
              padding: 8
            }}
          >
            {'\u00D7'}
          </button>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflow: 'auto', padding: '0 32px 32px' }}>
          {/* Orb Visual */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 32
          }}>
            <div style={{
              width: 120,
              height: 120,
              borderRadius: '50%',
              background: 'radial-gradient(circle at 30% 30%, #4a6fa5 0%, #1a2a4a 50%, #0a0a14 100%)',
              boxShadow: '0 0 60px rgba(74, 111, 165, 0.4), 0 0 120px rgba(74, 111, 165, 0.2)'
            }} />
          </div>

          {/* Conversation Display */}
          <div style={{ maxWidth: 800, margin: '0 auto' }}>
            {/* MAIA intro message */}
            <div style={{ marginBottom: 24 }}>
              <p style={{ color: '#d1d5db', fontSize: 15, lineHeight: 1.7, margin: '0 0 16px' }}>
                Hi, I'm Maia, the McClatchy AI Agent. I'm here to help you explore ideas, interpret information, and uncover useful insights.
              </p>
              <p style={{ color: '#d1d5db', fontSize: 15, margin: 0 }}>
                What insight question are you working on today?
              </p>
            </div>

            {/* Context from Insights Agent - shown as user message */}
            <div style={{
              backgroundColor: '#1e3a5f',
              borderRadius: 12,
              padding: 20,
              marginBottom: 24
            }}>
              <div style={{ fontSize: 14, color: '#93c5fd', lineHeight: 1.7 }}>
                I want to know more about functional drink macro trends and specifically about mushroom coffee. We will use this to inform our next trend articles.
              </div>
            </div>

            {/* MAIA response */}
            <div style={{ marginBottom: 24 }}>
              <p style={{ color: '#9ca3af', fontSize: 14, margin: '0 0 16px' }}>
                Let me look into that question for you...
              </p>
              <p style={{ color: '#d1d5db', fontSize: 14, lineHeight: 1.7, margin: '0 0 20px' }}>
                Since you're exploring functional drink macro trends and mushroom coffee for upcoming articles, I'd pull in a trends-focused agent alongside strong general reasoning models, and I can also help synthesize and structure the insights directly.
              </p>

              {/* Agent Selection */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 20 }}>
                {maiaAgents.map(agent => (
                  <button
                    key={agent.id}
                    onClick={() => toggleAgent(agent.id)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      padding: '10px 16px',
                      borderRadius: 20,
                      border: selectedAgents.includes(agent.id) ? `2px solid ${agent.color}` : '1px solid #374151',
                      backgroundColor: selectedAgents.includes(agent.id) ? `${agent.color}15` : '#1e1e32',
                      color: selectedAgents.includes(agent.id) ? '#f3f4f6' : '#9ca3af',
                      cursor: 'pointer',
                      fontSize: 13,
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <span>{agent.icon}</span>
                    <span>{agent.name}</span>
                  </button>
                ))}
              </div>

              <p style={{ color: '#9ca3af', fontSize: 14, margin: '0 0 20px', lineHeight: 1.6 }}>
                Please select which agents you would like to use for this query. Alternatively click "Answer Directly" and I'll provide a simple answer. If you want me to rewrite your query to be optimized for AI Agents, select Optimize & Answer
              </p>

              {/* Action Buttons */}
              <div style={{ display: 'flex', gap: 12, marginBottom: 32 }}>
                <button
                  onClick={runMaiaQuery}
                  style={{
                    padding: '10px 24px',
                    borderRadius: 8,
                    border: '1px solid #374151',
                    backgroundColor: 'transparent',
                    color: '#f3f4f6',
                    fontSize: 14,
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                >
                  Answer
                </button>
                <button
                  onClick={runMaiaQuery}
                  style={{
                    padding: '10px 24px',
                    borderRadius: 8,
                    border: '1px solid #6366f1',
                    backgroundColor: '#6366f120',
                    color: '#a5b4fc',
                    fontSize: 14,
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                >
                  Optimize & Answer
                </button>
              </div>
            </div>

            {/* Response Area */}
            {maiaResponse === 'loading' && (
              <div style={{
                padding: 40,
                textAlign: 'center',
                color: '#6b7280'
              }}>
                <div style={{
                  width: 48,
                  height: 48,
                  border: '3px solid #2d2d44',
                  borderTopColor: '#6366f1',
                  borderRadius: '50%',
                  margin: '0 auto 16px',
                  animation: 'spin 1s linear infinite'
                }} />
                <div style={{ fontSize: 14 }}>Synthesizing insights from {selectedAgents.length} agents...</div>
              </div>
            )}

            {maiaResponse && maiaResponse !== 'loading' && (
              <div style={{
                backgroundColor: '#1e1e32',
                borderRadius: 12,
                padding: 24,
                border: '1px solid #2d2d44'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                  <div style={{ fontSize: 12, color: '#6b7280' }}>Synthesized from:</div>
                  {maiaResponse.agents.map((agent, idx) => (
                    <span key={idx} style={{
                      padding: '4px 10px',
                      backgroundColor: '#252540',
                      borderRadius: 4,
                      fontSize: 12,
                      color: '#9ca3af'
                    }}>
                      {agent}
                    </span>
                  ))}
                </div>
                <div style={{
                  fontSize: 14,
                  color: '#d1d5db',
                  lineHeight: 1.8,
                  whiteSpace: 'pre-wrap'
                }}>
                  {maiaResponse.synthesizedInsight}
                </div>
                <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #2d2d44' }}>
                  <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8 }}>Sources Referenced:</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    {maiaResponse.sources.map((source, idx) => (
                      <span key={idx} style={{
                        padding: '4px 12px',
                        backgroundColor: '#252540',
                        borderRadius: 4,
                        fontSize: 12,
                        color: '#9ca3af'
                      }}>
                        {source.name}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Bottom Input */}
        <div style={{
          padding: '20px 32px',
          borderTop: '1px solid #1e1e32'
        }}>
          <div style={{ maxWidth: 800, margin: '0 auto' }}>
            {/* Input Area */}
            <div style={{
              backgroundColor: '#1e1e32',
              borderRadius: 12,
              padding: 16,
              display: 'flex',
              alignItems: 'flex-end',
              gap: 12,
              marginBottom: 16
            }}>
              <textarea
                value={maiaQuery}
                onChange={(e) => setMaiaQuery(e.target.value)}
                placeholder="Ask Maia about any topic"
                style={{
                  flex: 1,
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: '#f3f4f6',
                  fontSize: 14,
                  lineHeight: 1.5,
                  resize: 'none',
                  outline: 'none',
                  minHeight: 24,
                  maxHeight: 120,
                  fontFamily: 'inherit'
                }}
                rows={1}
              />
              <button
                onClick={runMaiaQuery}
                style={{
                  padding: '8px 20px',
                  borderRadius: 20,
                  border: 'none',
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  fontSize: 13,
                  fontWeight: '500',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}
              >
                Ask Maia
              </button>
            </div>

            {/* Save/Discard Actions */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div style={{ fontSize: 12, color: '#6b7280' }}>
                {maiaResponse && maiaResponse !== 'loading'
                  ? 'Research complete. Save to attach to opportunity record.'
                  : 'Research will be attached to opportunity record when saved.'}
              </div>
              <div style={{ display: 'flex', gap: 12 }}>
                <button
                  onClick={discardResearch}
                  style={{
                    padding: '10px 20px',
                    borderRadius: 8,
                    border: '1px solid #374151',
                    backgroundColor: 'transparent',
                    color: '#9ca3af',
                    fontSize: 13,
                    cursor: 'pointer'
                  }}
                >
                  Discard & Close
                </button>
                <button
                  onClick={saveResearchToOpportunity}
                  disabled={!maiaResponse || maiaResponse === 'loading'}
                  style={{
                    padding: '10px 20px',
                    borderRadius: 8,
                    border: 'none',
                    backgroundColor: maiaResponse && maiaResponse !== 'loading' ? '#10b981' : '#374151',
                    color: maiaResponse && maiaResponse !== 'loading' ? 'white' : '#6b7280',
                    fontSize: 13,
                    fontWeight: '600',
                    cursor: maiaResponse && maiaResponse !== 'loading' ? 'pointer' : 'not-allowed'
                  }}
                >
                  Save to Opportunity
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaiaModal;
